<template>
  <div>
    <h3>Install</h3>
    <div class="order-install" v-if="order">
      <div class="row">
        <div class="col">
          <div class="install-workflow">
            <div class="install-info">
              <h5>Install Info</h5>
              <div class="row">
                <div class="col">
                  <div>County: {{ order.siteAddress.county }}</div>
                  <div>APN: {{ order.siteAddress.apn }}</div>
                </div>
                <div class="col"></div>
              </div>
            </div>
            <div
              v-if="
                order.type == 'BUILDING' && order.workflow.install.doInstall
              "
              class="mt-3"
            >
              <install-estimate :order="order"></install-estimate>
            </div>
            <div class="checklist mt-3">
              <h5>Checklist</h5>
              <install-checklist :order="order"></install-checklist>
            </div>
            <notes
              :order="order"
              class="mt-4"
              department="INSTALL"
              :notesFilter="['INSTALL']"
              :showEvents="true"
            ></notes>
          </div>
        </div>
        <div class="col">
          <files-display
            :order="order"
            department="install"
          ></files-display>
          <photos-display
            class="mt-4"
            :order="order"
            department="install"
          ></photos-display>
        </div>
      </div>

      <!-- Crew Calculator - Full Width -->
      <div class="row mt-4" v-if="order.type == 'BUILDING' && order.workflow.install.doInstall && building">
        <div class="col">
          <crew-calculator :job-install-rate="jobInstallRate"></crew-calculator>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import PhotosDisplay from '@/components/PhotosDisplay'
import FilesDisplay from '@/components/FilesDisplay'
import InstallChecklist from '@/components/InstallChecklist'
import Notes from '@/components/Notes'
import InstallEstimate from '../components/InstallEstimate.vue'
import CrewCalculator from '../components/CrewCalculator.vue'

export default {
  name: 'OrderInstallPage',
  props: {},
  data: function () {
    return {
      order: null,
      building: null,
    }
  },
  components: {
    PhotosDisplay,
    Notes,
    FilesDisplay,
    InstallChecklist,
    InstallEstimate,
    CrewCalculator,
  },
  computed: {
    jobInstallRate() {
      if (!this.building) return 0
      
      const fullPrice = this.building.price?.kitAndInstall?.total || 0
      const salesTax = this.building.price?.kitAndInstall?.salesTax || 0
      const concreteCost = this.building.foundation?.price?.total || 0
      
      // Find grade-all cost in add-on items
      let gradeAllCost = 0
      const addOnArrays = [
        this.building.addOnItems,
        this.building.installAddOnItems,
        this.building.manualAddOnItems,
      ]
      
      for (const arr of addOnArrays) {
        if (arr && Array.isArray(arr)) {
          const gradeAllItem = arr.find(item => 
            item.name && item.name.toLowerCase().includes('grade')
          )
          if (gradeAllItem && gradeAllItem.total) {
            gradeAllCost = gradeAllItem.total
            break
          }
        }
      }
      
      const jobAmount = fullPrice - salesTax - concreteCost - gradeAllCost
      return jobAmount * 0.09
    },
  },
  mounted() {
    this.order = this.$parent.order
    this.fetchBuilding()
  },
  methods: {
    async fetchBuilding() {
      if (!this.order || !this.order.productId) return
      
      try {
        const response = await axios.get(`/services/buildings/${this.order.productId}`)
        this.building = response.data.building
      } catch (error) {
        console.error('Error fetching building:', error)
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
